import {
    CANDIDATE_ContactInfo_UPDATE_REQUEST,
    CANDIDATE_ContactInfo_UPDATE_SUCCESS,
    CANDIDATE_ContactInfo_UPDATE_FAIL,
} from "../constants/AuthConstant";

const initialState = {
    result: null,
    loading: null,
    error: null
};

const ContactInfoReducer = (state = initialState, action) => {
    switch (action.type) {
        case CANDIDATE_ContactInfo_UPDATE_REQUEST:
            return {
                ...state,
                loading: action.payload,
            };

        case CANDIDATE_ContactInfo_UPDATE_SUCCESS:
            return {
                ...state,
                result: action.result.data,
                loading: action.payload,
            };

        case CANDIDATE_ContactInfo_UPDATE_FAIL:
            return {
                ...state,
                error: action.error,
                loading: action.payload,
                msg: action.msg,
            };

        default:
            return state;
    }
};

export default ContactInfoReducer;